import * as React from 'react';

const onClickHandler = (submissionId, hasImages) => {
  if (hasImages && !confirm('This will delete all previously generated images. Do you want to continue?')) {
    return;
  }

  App.cable.subscriptions.subscriptions[0].perform('generate_images', {submission_id: submissionId})
}

export function Actions(props) {
  const {submissionId, hasImages} = props;

  return (
    <div className='actions'>
      <button type='button' onClick={() => onClickHandler(submissionId, hasImages)}>Generate images</button>
    </div>
  );
}
